import React from 'react';
import ReactDocumentTitle from 'react-document-title';
export var HubsDocumentTitle = function HubsDocumentTitle(_ref) {
  var title = _ref.title,
    shouldRenderDocumentTitle = _ref.shouldRenderDocumentTitle,
    children = _ref.children;
  if (!title || !shouldRenderDocumentTitle) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(ReactDocumentTitle, {
    title: title
  }, children);
};